module.exports = __webpack_public_path__ + "img/operation-account.af7083b2.png";